import React from 'react';
import styled from 'styled-components';
import { useGlobalContext } from '../context/globalContext';

function History() {
    const { transactionHistory } = useGlobalContext();

    const history = transactionHistory();

    return (
        <HistoryStyled>
            <h2>Recent History</h2>

            {history.length === 0 ? (
                <p>No transactions yet.</p>
            ) : (
                history.map((item) => {
                    const {
                        _id,
                        title,
                        amount,
                        type
                    } = item;

                    return (
                        <div
                            key={_id}
                            className="history-item"
                        >
                            <p
                                style={{
                                    color:
                                        type === 'expense'
                                            ? 'red'
                                            : 'var(--color-green)'
                                }}
                            >
                                {title}
                            </p>

                            <p
                                style={{
                                    color:
                                        type === 'expense'
                                            ? 'red'
                                            : 'var(--color-green)'
                                }}
                            >
                                {type === 'expense'
                                    ? `-₹${amount.toLocaleString()}`
                                    : `+₹${amount.toLocaleString()}`}
                            </p>
                        </div>
                    );
                })
            )}
        </HistoryStyled>
    );
}

const HistoryStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;

    .history-item {
        background: #fcf6f9;
        border: 2px solid #ffffff;
        box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.06);
        padding: 0.8rem 1rem;
        border-radius: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 0.5rem;
    }

    .history-item p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .history-item p:first-child {
        flex: 1;
        min-width: 0;
    }

    .history-item p:last-child {
        flex-shrink: 0;
    }
`;

export default History;